<template>
  <Transition>
    <div
      v-show="message"
      class="alert fade show alert-dismissable"
      :class="`alert-${status}`"
    >
      {{ message }}
    </div>
  </Transition>
</template>

<script>
export default {
  name: 'Alert',
  props: {
    status: { type: String, required: true, },
    message: { type: String, required: true, default: ""},
  },
  emits: ["alertDisplayed"],
  watch: {
    message(newVal) {
      if (newVal) {
        this.$emit(`alertDisplayed`);
      }
    }
  }
}
</script>
